module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/MG-afc87009763405b9983bd85c9f454a63.png";